<template>
  <v-timeline-item
    v-if="conversion"
    dot-color="leadActivity"
    icon="mdi-file-document-outline"
    fill-dot
  >
    <v-expansion-panels
      class="expansion-panels"
      variant="accordion"
      flat
    >
      <v-expansion-panel>
        <v-expansion-panel-title>
          <v-row
            no-gutters
            align="center"
            class="d-flex justify-center"
            :class="{ 'flex-column': $vuetify.display.smAndDown }"
          >
            <v-col md="8">
              <div class="mb-2 text-subtitle-1">
                <span
                  v-if="conversion.download.postalShipping !== 'NONE'"
                  v-html="$t('lead-timeline.download.title-postal-shipping', { type }) + ' '"
                />

                <span
                  v-else
                  v-text="$t('lead-timeline.download.title', { type })"
                />
                <span v-if="conversion.download.postalShipping === 'AUTOMATIC'">{{
                  $t('lead-timeline.download.title-postal-shipping-automatic')
                }}</span>
                <span v-if="conversion.download.postalShipping === 'MANUAL'">{{
                  $t('lead-timeline.download.title-postal-shipping-manual')
                }}</span>
              </div>
              <div
                v-show="true"
                class="text-grey"
              >
                {{ landingpageName }}
              </div>
              <div v-if="conversion.postalShipping !== 'NONE'">
                <div
                  v-if="conversion.personalData.address"
                  class="text-grey"
                >
                  {{ conversion.personalData.address.street }}
                  {{ conversion.personalData.address.houseNumber }} •
                  {{ conversion.personalData.address.zip }}
                  {{ conversion.personalData.address.city }}
                </div>
              </div>
            </v-col>
            <v-col
              class="text-right text-grey pr-2"
              :class="{ 'text-start mt-2': $vuetify.display.smAndDown }"
              md="4"
            >
              {{ formatDate(data.createdAt) }}
            </v-col>
          </v-row>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row>
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title> {{ $t('labels.source') }}: </v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ source }}
                  </div>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col
              v-if="conversion.download.postalShipping !== 'NONE'"
              cols="12"
              md="6"
              class="py-0"
            >
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title> {{ $t('labels.postal-shipping') }}: </v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ postalShipping(conversion.download.postalShipping) }}
                  </div>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col
              md="6"
              class="pb-0"
            >
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title> {{ $t('labels.personal-data') }}: </v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ name }}
                  </div>
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ phone }}
                  </div>
                  <div
                    v-if="conversion.personalData.address"
                    class="text-grey text--darken-3 text-body-2"
                  >
                    <div>
                      {{ conversion.personalData.address.street }}
                      {{ conversion.personalData.address.houseNumber }}
                    </div>
                    <div>
                      {{ conversion.personalData.address.zip }}
                      {{ conversion.personalData.address.city }}
                    </div>
                    <div>
                      {{ country(conversion.personalData.address.country) }}
                    </div>
                  </div>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title>{{ $t('labels.utm-source') }}:</v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ utmSource || $t('labels.none') }}
                  </div>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col
              v-if="utmMedium"
              cols="12"
              md="6"
              class="py-0"
            >
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title>{{ $t('labels.utm-medium') }}:</v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">{{ utmMedium }}</div>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col
              v-if="utmCampaign"
              cols="12"
              md="6"
              class="py-0"
            >
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title>{{ $t('labels.utm-campaign') }}:</v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">{{ utmCampaign }}</div>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col
              v-if="utmContent"
              cols="12"
              md="6"
              class="py-0"
            >
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title>{{ $t('labels.utm-content') }}:</v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">{{ utmContent }}</div>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col
              v-if="utmTerm"
              cols="12"
              md="6"
              class="py-0"
            >
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title>{{ $t('labels.utm-term') }}:</v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">{{ utmTerm }}</div>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>

          <!-- Render custom fields from the conversion if available -->
          <v-row v-if="conversion.customFields?.length">
            <v-col
              cols="12"
              md="6"
              v-for="(field, index) in conversion.customFields"
              :key="index"
              class="py-0"
            >
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title :title="field.label">{{ field.label }}:</v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ field.value }}
                  </div>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>

          <!-- Postal shipping notice / tip -->
          <v-row v-if="conversion.download.postalShipping === 'MANUAL'">
            <v-col class="font-smaller">
              <strong>{{ $t('labels.our-tip') }}:<br /></strong>
              {{ $t('lead-timeline.download.tip-shipping') }}
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-timeline-item>
</template>

<script>
import { conversionSource } from '@/lib/conversionSource'
import countries from '@/mixins/countries'

import CONVERSION from '../queries/Conversion.gql'

const POSTAL_SHIPPING_TYPES = {
  AUTOMATIC: 'labels.postal-shipping-types.automatic',
  MANUAL: 'labels.postal-shipping-types.manual',
  NONE: 'labels.postal-shipping-types.none',
}

export default {
  mixins: [countries],
  props: {
    data: { type: Object, default: null },
  },
  data() {
    return {
      conversion: null,
    }
  },
  computed: {
    type() {
      if (!this.conversion) return
      return this.conversion.landingpage.type === 'CHECKLIST'
        ? this.$t('labels.one-checklist')
        : this.$t('labels.one-guide')
    },
    source() {
      if (!this.conversion) return
      return this.conversion.source || conversionSource[this.conversion.origin] || ''
    },
    landingpageName() {
      if (!this.conversion) return
      return this.conversion.landingpage.name
    },
    name() {
      if (!this.conversion) return
      if (!(this.conversion.personalData.firstname && this.conversion.personalData.lastname))
        return ''
      return `${this.conversion.personalData.firstname} ${this.conversion.personalData.lastname}`
    },
    phone() {
      if (!this.conversion) return
      if (!this.conversion.personalData.formattedPhone) return ''
      return this.conversion.personalData.formattedPhone
    },
    utmSource() {
      return this.conversion?.utmParams?.source || ''
    },
    utmMedium() {
      return this.conversion?.utmParams?.medium || ''
    },
    utmCampaign() {
      return this.conversion?.utmParams?.campaign || ''
    },
    utmContent() {
      return this.conversion?.utmParams?.content || ''
    },
    utmTerm() {
      return this.conversion?.utmParams?.term || ''
    },
  },
  methods: {
    postalShipping(type) {
      return this.$t(POSTAL_SHIPPING_TYPES[type])
    },
    country(value) {
      return this.availableCountryItems[value.toUpperCase()]
    },
  },
  apollo: {
    conversion: {
      query: CONVERSION,
      variables() {
        return {
          conversionId: this.data.details[this.data.type].conversionId,
        }
      },
    },
  },
}
</script>

<style scoped>
.expansion-panels {
  margin: -24px -24px 0 -24px;
}
</style>
